module.exports = __webpack_public_path__ + "img/1_b.44f5e7e8.svg";